import MainLayout from "@zenith/layouts/MainLayout/main-layout/main-layout";
import SettingsSidebar from "./settings-sidebar/settings-sidebar";
import { memo } from "react";

const SettingsLayout = memo(function SettingsLayout() {
  return <MainLayout sidebar={SettingsSidebar} />;
});

export default SettingsLayout;
